import { chattingRepository } from '~/api/repository/chatting';

const MESSAGES_LIMIT = 50;

export const CHATTING_QUERY_KEY = {
  all: (roomId: string) => ['/api/market-place/chat/rooms', roomId] as const,

  /** 전체 읽지 않은 메시지 수 */
  totalUnreadCount: () => ({
    queryKey: ['/api/market-place/chat/unread-count'] as const,
    queryFn: () => chattingRepository.getTotalUnreadCount(),
  }),

  /** 채팅 메시지 목록 (offset 기반 페이지네이션) */
  messages: (roomId: string, offset: number) => ({
    queryKey: [
      '/api/market-place/chat/rooms',
      roomId,
      'messages',
      offset,
    ] as const,
    queryFn: () =>
      chattingRepository.getMessages(roomId, {
        offset,
        limit: MESSAGES_LIMIT,
      }),
  }),

  /** 알람 채팅방 목록 */
  alarmRooms: () => ({
    queryKey: ['/api/market-place/chat/rooms/alarm'] as const,
    queryFn: () => chattingRepository.getAlarmChatRooms(),
  }),

  /** 단일 알람 채팅방 */
  alarmRoom: (roomId: number) => ({
    queryKey: ['/api/market-place/chat/rooms', roomId] as const,
    queryFn: () => chattingRepository.getAlarmChatRoom(roomId),
  }),

  /** 채팅방 푸시 알림 수신 여부 */
  pushEnabled: (roomId: string) => ({
    queryKey: ['/api/market-place/chat/rooms', roomId, 'push-enabled'] as const,
    queryFn: () => chattingRepository.getPushEnabled(roomId),
  }),
};
